module.exports = new __parcel__URL__("hierarchy-window.725ed8e1.svg").toString();